import FAQ from "../components/FAQ";
import Footer from "../components/Footer";
import Header from "../components/Header";

function FIFAWorldCup2026() {
  return (
    <>
      <section 
      className="relative w-full min-h-[40vh] sm:min-h-[50vh] lg:min-h-[60vh] bg-cover bg-center"
      style={{
        backgroundImage: "url('blog13.png')",
      }}
    >
      <Header/>

      {/* Hero Content */}
      <div className="relative z-20 flex items-center justify-center min-h-[40vh] sm:min-h-[50vh] lg:min-h-[60vh] px-4 sm:px-6">
        <div className="max-w-5xl text-center text-white">
          <h1 className="font-bold text-xl sm:text-2xl md:text-3xl lg:text-4xl leading-snug text-white">
            FIFA World Cup 2026 Transportation
          </h1>
          <div className="mt-4 sm:mt-6 flex justify-center gap-2 text-xs sm:text-sm font-medium">
            <a href="/" className="hover:text-logo-green">Home</a>
            <span>-</span>
            <span className="text-logo-green">FIFA World Cup 2026</span>
          </div>
        </div>
      </div>
    </section>

    <section className="bg-white py-12 sm:py-16 px-4 sm:px-6 lg:px-10">
        <div className="max-w-[1200px] mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
            {/* Image Side - First on mobile, left on desktop */}
            <div className="order-1 lg:order-1">
              <img 
                src="fifa2.avif" 
                alt="Luxury Fleet" 
                className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
              />
            </div>

            {/* Text Side - Second on mobile, right on desktop */}
            <div className="order-2 lg:order-2">
              <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-black mb-3 sm:mb-4 leading-tight">
                Your Seamless FIFA World Cup 2026 Transport Experience
              </h2>
              <p className="text-sm sm:text-base lg:text-lg mb-3 sm:mb-4 leading-relaxed text-gray-900">
                The 2026 FIFA World Cup is set to bring an electric atmosphere to NYC, and Mercedes Benz Stadium will be at the heart of the action. Navigating the city on matchday requires a strategic and reliable transportation plan. Our specialized service is dedicated to providing top-tier private and group transportation solutions for this global event. Whether you are a corporate sponsor requiring executive VIP transport or a supporters' club traveling en masse, our diverse fleet and professional chauffeurs ensure a punctual, safe, and luxurious journey to and from the stadium. Plan ahead and book the ultimate game day experience.
              </p>
             
              <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
                <a 
                  href="/booknow" 
                  className="bg-black border-2 border-white text-white px-4 sm:px-6 lg:px-8 py-2 sm:py-3 text-sm sm:text-base font-semibold hover:bg-gray-900 transition-colors text-center"
                >
                  BOOK NOW
                </a>
                
                <a 
                  href="tel:+17182004140" 
                  className="bg-white text-black border-2 border-black px-4 sm:px-6 lg:px-8 py-2 sm:py-3 text-sm sm:text-base font-semibold hover:bg-gray-100 transition-colors text-center"
                >
                  CALL NOW
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Premium Transportation Section */}
      <section className="py-8 sm:py-12 lg:py-16 px-4 md:px-6 lg:px-10 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 sm:gap-8 lg:gap-12 items-start">
            
            {/* Left Side - Services List (35%) */}
            <div className="lg:col-span-4 order-2 lg:order-1">
              <h3 className="text-base sm:text-lg font-semibold text-gray-600 mb-2 uppercase tracking-wide">SERVICES</h3>
              
              <div className="space-y-2 sm:space-y-3 mb-6 sm:mb-8">
                <a href="/airport-transfer-service" className="flex items-center justify-between py-2 sm:py-3 border-b border-gray-200 hover:bg-gray-50 transition-colors group">
                  <span className="text-sm sm:text-base text-gray-800 font-medium group-hover:text-logo-green">Airport Transfers</span>
                  <svg className="w-4 h-4 sm:w-5 sm:h-5 text-gray-400 group-hover:text-logo-green" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </a>
                
                <a href="/hourly-limo-service" className="flex items-center justify-between py-2 sm:py-3 border-b border-gray-200 hover:bg-gray-50 transition-colors group">
                  <span className="text-sm sm:text-base text-gray-800 font-medium group-hover:text-logo-green">Hourly Service</span>
                  <svg className="w-4 h-4 sm:w-5 sm:h-5 text-gray-400 group-hover:text-logo-green" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </a>
                
                <a href="/corporate-limo-service" className="flex items-center justify-between py-2 sm:py-3 border-b border-gray-200 hover:bg-gray-50 transition-colors group">
                  <span className="text-sm sm:text-base text-gray-800 font-medium group-hover:text-logo-green">Corporate Service</span>
                  <svg className="w-4 h-4 sm:w-5 sm:h-5 text-gray-400 group-hover:text-logo-green" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </a>
                
                <a href="/wedding-limousine-service" className="flex items-center justify-between py-2 sm:py-3 border-b border-gray-200 hover:bg-gray-50 transition-colors group">
                  <span className="text-sm sm:text-base text-gray-800 font-medium group-hover:text-logo-green">Wedding Transportation</span>
                  <svg className="w-4 h-4 sm:w-5 sm:h-5 text-gray-400 group-hover:text-logo-green" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </a>
                
                <a href="/group-transportation" className="flex items-center justify-between py-2 sm:py-3 border-b border-gray-200 hover:bg-gray-50 transition-colors group">
                  <span className="text-sm sm:text-base text-gray-800 font-medium group-hover:text-logo-green">Group Transportation</span>
                  <svg className="w-4 h-4 sm:w-5 sm:h-5 text-gray-400 group-hover:text-logo-green" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </a>
                
                <a href="/city-transfer" className="flex items-center justify-between py-2 sm:py-3 border-b border-gray-200 hover:bg-gray-50 transition-colors group">
                  <span className="text-sm sm:text-base text-gray-800 font-medium group-hover:text-logo-green">City Transfers</span>
                  <svg className="w-4 h-4 sm:w-5 sm:h-5 text-gray-400 group-hover:text-logo-green" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </a>
              </div>
            </div>

            {/* Right Side - Content (65%) */}
            <div className="lg:col-span-8 relative order-1 lg:order-2">
              {/* Stadium Image */}
              <div className="mb-6 sm:mb-8">
                <img 
                  src="fifa1.webp" 
                  alt="Mercedes-Benz Stadium" 
                  className="w-full h-[150px] sm:h-[200px] lg:h-[250px] object-cover rounded-lg shadow-lg"
                />
              </div>
              
              <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-gray-900 mb-4 sm:mb-6 leading-tight">
                Our World Cup Transportation Fleet: Vehicles for Every Group Size
              </h2>
              
              <div className="mb-4 sm:mb-6">
                <p className="text-sm sm:text-base lg:text-lg text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  The 2026 FIFA World Cup is set to bring an electric atmosphere to Atlanta, and <span className="text-black font-semibold">Mercedes-Benz Stadium</span> will be at the heart of the action. Navigating the city on matchday requires a strategic and reliable transportation plan. Our specialized service is dedicated to providing top-tier private and group transportation solutions for this global event.
                </p>
              </div>

              {/* Action Buttons */}
              <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
                <a 
                  href="/booknow" 
                  className="bg-black hover:bg-gray-900 text-white px-6 sm:px-8 py-2 sm:py-3 text-sm sm:text-base lg:text-lg font-bold rounded-full transition-all duration-300 text-center"
                >
                  BOOK NOW
                </a>
                
                <a 
                  href="tel:+17182004140" 
                  className="bg-transparent border-2 border-black hover:bg-gray-100 text-black px-6 sm:px-8 py-2 sm:py-3 text-sm sm:text-base lg:text-lg font-bold rounded-full transition-all duration-300 text-center"
                >
                  CALL NOW
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FIFA World Cup 2026 Matches Schedule Section */}
      <section className="py-6 sm:py-8 bg-white px-4 md:px-6 lg:px-10">

        {/* Service Area Cities */}
          <div className="mt-2 mb-8 sm:mb-12">
            <h3 className="text-xl sm:text-2xl font-bold text-gray-900 text-center mb-6 sm:mb-8">
              Our FIFA World Cup 2026 Service Areas
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 sm:gap-4">
              {[
                { name: "New York City", state: "NY" },
                { name: "New Jersey", state: "NJ" },
                { name: "Philadelphia", state: "PA" },
                { name: "Washington DC", state: "DC" },
                { name: "Connecticut", state: "CT" },
                { name: "Rhode Island", state: "RI" }
              ].map((city, index) => (
                <div key={index} className="bg-white rounded-lg p-3 sm:p-4 text-center shadow border border-gray-200 hover:shadow-md transition-shadow">
                  <div className="text-xs sm:text-sm font-semibold text-gray-900">{city.name}</div>
                  <div className="text-xs text-gray-500">{city.state}</div>
                </div>
              ))}
            </div>
          </div>
        <div className="max-w-7xl mx-auto">
          
          {/* Section Header */}
          <div className="text-center mb-8 sm:mb-10">
            
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
              FIFA World Cup 2026 Matches Schedule
            </h2>
            <p className="text-sm sm:text-base lg:text-lg text-gray-600 max-w-3xl mx-auto">
              The 2026 FIFA World Cup will be hosted across multiple cities in the United States. 
              We provide luxury transportation services to all major venues in our service area.
            </p>
          </div>

          {/* Professional Table Container */}
          <div className="bg-white rounded-lg shadow-lg overflow-hidden border border-gray-300">
            
            {/* Table Header */}
            <div className="bg-gray-900 px-4 sm:px-6 py-3 sm:py-4">
              <h3 className="text-lg sm:text-xl font-bold text-white text-center">
                FIFA World Cup 2026 - Northeast Region Schedule
              </h3>
            </div>

            {/* Responsive Table */}
            <div className="overflow-x-auto">
              <table className="w-full min-w-[600px]">
                <thead className="bg-gray-800 text-white">
                  <tr>
                    <th className="px-3 sm:px-6 py-3 sm:py-4 text-left font-semibold text-xs sm:text-sm uppercase tracking-wider">
                      Date
                    </th>
                    <th className="px-3 sm:px-6 py-3 sm:py-4 text-left font-semibold text-xs sm:text-sm uppercase tracking-wider">
                      Stage
                    </th>
                    <th className="px-3 sm:px-6 py-3 sm:py-4 text-left font-semibold text-xs sm:text-sm uppercase tracking-wider">
                      Match
                    </th>
                    <th className="px-3 sm:px-6 py-3 sm:py-4 text-left font-semibold text-xs sm:text-sm uppercase tracking-wider">
                      Venue & City
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {[
                    ["June 12, 2026", "Group Stage", "Opening Match", "MetLife Stadium", "New Jersey"],
                    ["June 15, 2026", "Group Stage", "Group Match", "Lincoln Financial Field", "Philadelphia, PA"],
                    ["June 18, 2026", "Group Stage", "Group Match", "MetLife Stadium", "New Jersey"],
                    ["June 21, 2026", "Group Stage", "Group Match", "Gillette Stadium", "Boston Area"],
                    ["June 24, 2026", "Group Stage", "Group Match", "Lincoln Financial Field", "Philadelphia, PA"],
                    ["June 27, 2026", "Group Stage", "Group Match", "MetLife Stadium", "New Jersey"],
                    ["June 30, 2026", "Round of 32", "Knockout Stage", "MetLife Stadium", "New Jersey"],
                    ["July 3, 2026", "Round of 32", "Knockout Stage", "Lincoln Financial Field", "Philadelphia, PA"],
                    ["July 7, 2026", "Round of 16", "Round of 16", "MetLife Stadium", "New Jersey"],
                    ["July 11, 2026", "Quarterfinal", "Quarterfinal", "MetLife Stadium", "New Jersey"],
                    ["July 15, 2026", "Semifinal", "Semifinal", "MetLife Stadium", "New Jersey"],
                    ["July 19, 2026", "Final", "World Cup Final", "MetLife Stadium", "New Jersey"],
                  ].map((row, i) => (
                    <tr key={i} className="hover:bg-gray-50 transition-colors">
                      <td className="px-3 sm:px-6 py-3 sm:py-4 whitespace-nowrap">
                        <div className="text-xs sm:text-sm font-medium text-gray-900">{row[0]}</div>
                        <div className="text-xs text-gray-500">Eastern Time</div>
                      </td>
                      <td className="px-3 sm:px-6 py-3 sm:py-4 whitespace-nowrap">
                        <span className={`inline-flex px-2 sm:px-3 py-1 rounded text-xs font-semibold ${
                          row[1] === 'Group Stage' 
                            ? 'bg-gray-100 text-gray-800' 
                            : row[1] === 'Final'
                            ? 'bg-black text-white'
                            : row[1] === 'Semifinal' || row[1] === 'Quarterfinal'
                            ? 'bg-gray-700 text-white'
                            : 'bg-gray-200 text-gray-800'
                        }`}>
                          {row[1]}
                        </span>
                      </td>
                      <td className="px-3 sm:px-6 py-3 sm:py-4 whitespace-nowrap">
                        <div className="text-xs sm:text-sm font-medium text-gray-900">{row[2]}</div>
                        <div className="text-xs text-gray-500">Teams TBD</div>
                      </td>
                      <td className="px-3 sm:px-6 py-3 sm:py-4 whitespace-nowrap">
                        <div className="text-xs sm:text-sm font-medium text-gray-900">{row[3]}</div>
                        <div className="text-xs text-gray-500">{row[4]}</div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Table Footer */}
            <div className="bg-gray-50 px-4 sm:px-6 py-3 sm:py-4 border-t border-gray-200">
              <div className="flex flex-col sm:flex-row items-center justify-between gap-3 sm:gap-0">
                <div className="text-center sm:text-left">
                  <p className="text-xs sm:text-sm text-gray-600">
                    <span className="font-semibold text-gray-900">12 matches</span> across our service area
                  </p>
                  <p className="text-xs text-gray-500">Professional transportation available to all venues</p>
                </div>
                <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 w-full sm:w-auto">
                  <a 
                    href="/booknow" 
                    className="bg-gray-900 hover:bg-gray-800 text-white px-4 sm:px-6 py-2 rounded font-semibold text-xs sm:text-sm transition-colors text-center"
                  >
                    Book Transportation
                  </a>
                  <a 
                    href="tel:+17182004140" 
                    className="bg-white border border-gray-900 hover:bg-gray-900 hover:text-white text-gray-900 px-4 sm:px-6 py-2 rounded font-semibold text-xs sm:text-sm transition-colors text-center"
                  >
                    Call Now
                  </a>
                </div>
              </div>
            </div>
          </div>

          
          

            

            
        </div>
      </section>

      

      {/* Main Content Section */}
      <section className="py-6 sm:py-8 px-4 md:px-6 lg:px-10 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-6xl mx-auto">
          
          {/* Introduction */}
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4 sm:mb-6">
              Experience the FIFA World Cup 2026 in Ultimate Luxury
            </h2>
            <p className="text-sm sm:text-base lg:text-lg xl:text-xl text-gray-700 leading-relaxed max-w-4xl mx-auto">
              The FIFA World Cup 2026 is coming to North America, and we're here to make your experience unforgettable. 
              Whether you're attending matches, exploring host cities, or celebrating with fellow fans, our premium 
              transportation services ensure you travel in comfort and style.
            </p>
          </div>

          {/* Special Offer Section */}
          <div 
            className="relative min-h-[300px] sm:min-h-[350px] lg:min-h-[400px] rounded-lg p-6 sm:p-8 md:p-12 lg:p-18 text-white mb-12 sm:mb-16 border border-gray-300 bg-cover bg-center flex items-center justify-center"
            style={{
              backgroundImage: "url('may1.webp')",
            }}
          >
            {/* Dark overlay for better text readability */}
            <div className="absolute inset-0 bg-black bg-opacity-60 rounded-lg"></div>
            
            <div className="relative z-10 text-center max-w-4xl mx-auto">
              <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-3 sm:mb-4 text-white">
                FIFA World Cup 2026 Special Rates
              </h3>
              <p className="text-lg sm:text-xl md:text-2xl mb-4 sm:mb-6">
                Save up to <span className="font-bold text-gray-300">20% OFF</span> on all luxury transfers
              </p>
              <p className="text-sm sm:text-base lg:text-lg mb-6 sm:mb-8 text-gray-300">
                Valid during the entire World Cup season. Book early to secure your preferred vehicles and routes.
              </p>
              <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
                <a 
                  href="/booknow" 
                  className="bg-white hover:bg-gray-100 text-gray-900 px-6 sm:px-8 py-3 sm:py-4 text-sm sm:text-base lg:text-lg font-bold rounded transition-all duration-300 text-center"
                >
                  BOOK NOW & SAVE
                </a>
                <a 
                  href="tel:+17182004140" 
                  className="bg-transparent border-2 border-white hover:bg-white hover:text-gray-900 text-white px-6 sm:px-8 py-3 sm:py-4 text-sm sm:text-base lg:text-lg font-bold rounded transition-all duration-300 text-center"
                >
                  CALL NOW
                </a>
              </div>
            </div>
          </div>

          
          
         
        </div>
      </section>

      


      

      <FAQ/>
      <Footer/>
    </>
  );
}

export default FIFAWorldCup2026;
